import SectionItem from './SectionItem';

export default SectionItem;
